import {Card} from 'platform/components';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {ContextTarget, RestrictionActionContext} from '../constants/issueRestrictionAlerts';
import {CheckoutPaymentCard} from './CheckoutPaymentCard';

interface CorrectiveTaxDocumentCardProps extends RequiredTestIdProps {
  paymentId: string;
  checkoutId: string;
  customerId: string;
  contextTarget?: ContextTarget;
  contextId?: string;
  actionContext?: RestrictionActionContext;
  serviceCaseId?: string;
  serviceOrderId?: string;
  isEditingDisabled?: boolean;
  isCompletingDisabled?: boolean;
}

export function CorrectiveTaxDocumentCard(props: CorrectiveTaxDocumentCardProps) {
  return (
    <Card variant="inlineGrey">
      <CheckoutPaymentCard
        paymentId={props.paymentId}
        checkoutId={props.checkoutId}
        customerId={props.customerId}
        serviceCaseId={props.serviceCaseId}
        serviceOrderId={props.serviceOrderId}
        isEditingDisabled={props.isEditingDisabled}
        isCompletingDisabled={props.isCompletingDisabled}
        contextTarget={props.contextTarget}
        contextId={props.contextId}
        actionContext={props.actionContext}
        data-testid={suffixTestId('card', props)}
      />
    </Card>
  );
}
